import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { UsersModule } from './users/users.module';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AuthModule } from './auth/auth.module';
import { JwtModule } from '@nestjs/jwt';
import { appConfig } from '../../config';
import { ScheduleModule } from '@nestjs/schedule';
import { DataSource } from 'typeorm';
import { AppDataSource } from './app-datasource';
import { UnitsDataModule } from './job-work-masters/units-master/units-module';
import { JobWorkModule } from './job-work-masters/job-work/job-work-module';
import { JobworkAgainstUnitModule } from './job-work-masters/job-work-approval-against-unit/job-work-approval-module';
import { VendorModule } from './vendor-registration/vendor-registration.module';
import { JobworkCreationModule } from './job-work/job-work-creation/job-work-creation-module';


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: "mysql",
      timezone: 'Z',
      host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      autoLoadEntities: true,
      synchronize: false,
      logging: true,
      extra: {
        connectionLimit: 20
      }
    }),
    UsersModule,
    AuthModule, JwtModule, JobWorkModule, UnitsDataModule, JobworkAgainstUnitModule, JobworkCreationModule,
   VendorModule],
  controllers: [AppController],
  providers: [AppService, {
    provide: DataSource,
    useFactory: async () => {
      await AppDataSource.initialize()
        .then(() => {
          console.log('Data Source has been initialized!');
        })
        .catch((err) => {
          console.error('Error during Data Source initialization', err);
        });
      // await AppDataSource1.initialize()
      //   .then(() => {
      //     console.log('Data Source has been initialized!');
      //   })
      //   .catch((err) => {
      //     console.error('Error during Data Source initialization', err);
      //   });
      // await AppDataSource2.initialize()
      //   .then(() => {
      //     console.log('Data Source has been initialized!');
      //   })
      //   .catch((err) => {
      //     console.error('Error during Data Source initialization', err);
      //   });
    }
  }],
})
export class AppModule { }
